<!-- <ng-container *ngIf="isLoading; else pageTemplate">
    <app-loader></app-loader>
</ng-container> -->

<ng-container *ngIf="isAuthenticated$ | async; else loginTemplate">
    <router-outlet></router-outlet>
    <!--<app-loader></app-loader>-->
    <app-auth-alert></app-auth-alert>
    <app-consent-modal></app-consent-modal>
</ng-container>

<ng-template #loginTemplate>
    <!-- <div class="nav-logo">
        <img alt="Genpact" height="50px" src="assets/images/genpact.svg" />
    </div>
    <main class="d-flex justify-content-center align-items-center">
        <div class="form-signin w-100 m-auto">
            <form>
                <img class="mb-4" src="assets/icons/icon-72x72.png" alt="Scout" width="72" height="72">
                <h2 class="h3 mb-3 fw-bold">Scout</h2>
                <p class="text-secondary">Sign in to get started</p>


                <button (click)="login()" class="btn btn-primary text-white w-100 py-2" type="submit">Sign in</button>
            </form>
        </div>
    </main> -->

    <div class="loader-box">
        <div  class="row" >
            <div class="col-md-12">
                <div class="loader" id="loader" ></div>
            </div>
        </div>
    </div>
</ng-template>

<ngb-toast *ngIf="updateAvailable" [autohide]="false" (hidden)="updateAvailable=false"
    class="position-fixed bg-white position-right top-0 z-99 m-3">
    <div class="d-flex align-items-center">
        <span class="me-auto">New version of Scout available!</span>
        <button class="btn btn-primary text-white btn-sm ms-2" (click)="updateApp()">
            Update Now
        </button>
    </div>
</ngb-toast> 